<div
  class="tab-pane fade"
  id="prebooking"
  role="tabpanel"
  aria-labelledby="prebooking-tab"
>
  <div class="booking-table-container">
    <div class="table-responsive">
      <table class="table" id="example">
        <thead class="table-light-bg">
          <tr>
            <th scope="col">Name</th>
            <th scope="col">
              Departure date <i class="fas fa-chevron-down"></i>
            </th>
            <th scope="col">Country <i class="fas fa-chevron-down"></i></th>
            <th scope="col">
              Price <span>($)</span> <i class="fas fa-chevron-down"></i>
            </th>
            <th scope="col">Contact</th>
            <th scope="col">Booking date <i class="fas fa-chevron-up"></i></th>
            <th scope="col">Payment <i class="fas fa-chevron-down"></i></th>

            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="review-image">
                <img src="img/user.jpg" alt="" />
              </div>

              <div class="review-name">
                James Harold
                <p>jamesharold@email.com</p>
              </div>
            </td>
            <td>
              12-09-2018
              <p>12:08 pm</p>
            </td>
            <td>England</td>
            <td>1400</td>
            <td>+190 3993 494</td>
            <td>12-08-2018</td>
            <td>Stripe</td>

            <td>
              <div class="ellipsis-btn">
                <a
                  href="#"
                  class="btn dropdown-toggle"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  <i class="fas fa-ellipsis-v"></i>
                </a>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" href="#">View</a>
                  <a class="dropdown-item" href="#">Edit</a>
                  <a class="dropdown-item" href="#">Delete</a>
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div class="review-image">
                <img src="img/user.jpg" alt="" />
              </div>

              <div class="review-name">
                James Harold
                <p>jamesharold@email.com</p>
              </div>
            </td>
            <td>
              12-09-2018
              <p>12:08 pm</p>
            </td>
            <td>England</td>
            <td>1400</td>
            <td>+190 3993 494</td>
            <td>12-08-2018</td>
            <td>Stripe</td>

            <td>
              <div class="ellipsis-btn">
                <a
                  href="#"
                  class="btn dropdown-toggle"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  <i class="fas fa-ellipsis-v"></i>
                </a>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" href="#">View</a>
                  <a class="dropdown-item" href="#">Edit</a>
                  <a class="dropdown-item" href="#">Delete</a>
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div class="review-image">
                <img src="img/user.jpg" alt="" />
              </div>

              <div class="review-name">
                James Harold
                <p>jamesharold@email.com</p>
              </div>
            </td>
            <td>
              12-09-2018
              <p>12:08 pm</p>
            </td>
            <td>England</td>
            <td>1400</td>
            <td>+190 3993 494</td>
            <td>12-08-2018</td>
            <td>Stripe</td>

            <td>
              <div class="ellipsis-btn">
                <a
                  href="#"
                  class="btn dropdown-toggle"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  <i class="fas fa-ellipsis-v"></i>
                </a>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" href="#">View</a>
                  <a class="dropdown-item" href="#">Edit</a>
                  <a class="dropdown-item" href="#">Delete</a>
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div class="review-image">
                <img src="img/user.jpg" alt="" />
              </div>

              <div class="review-name">
                James Harold
                <p>jamesharold@email.com</p>
              </div>
            </td>
            <td>
              12-09-2018
              <p>12:08 pm</p>
            </td>
            <td>England</td>
            <td>1400</td>
            <td>+190 3993 494</td>
            <td>12-08-2018</td>
            <td>Stripe</td>

            <td>
              <div class="ellipsis-btn">
                <a
                  href="#"
                  class="btn dropdown-toggle"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  <i class="fas fa-ellipsis-v"></i>
                </a>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" href="#">View</a>
                  <a class="dropdown-item" href="#">Edit</a>
                  <a class="dropdown-item" href="#">Delete</a>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
